module.exports = __webpack_public_path__ + "media/2.f1aa07a1.wav";